import { HistoryItem, HistoryItemsByYearDate } from './types';
import { format, formatDistanceToNow } from 'date-fns';

const oneHour = 1000 * 60 * 60;

export const buildFooterText = (item: HistoryItem): string => {
  const { profile, created } = item;

  // Footer Text
  let footerTimestamp = format(created, `h:mmaaa`);
  if (footerTimestamp === '12:00am') {
    footerTimestamp = '';
  }

  const isRecent = Date.now() > created && Date.now() - created < oneHour;
  const computedFooterTimestamp = isRecent
    ? formatDistanceToNow(created, {
        addSuffix: true,
      })
    : footerTimestamp;

  const parts: string[] = [];

  if (computedFooterTimestamp) {
    parts.push(computedFooterTimestamp);
  }

  if (profile?.name) {
    parts.push(profile.name);
  }

  return parts.join(' • ');
};

export const sortHistoryItems = (a: HistoryItem, b: HistoryItem) =>
  b.created === a.created
    ? parseInt(b.id, 10) - parseInt(a.id, 10)
    : b.created - a.created;

export const groupHistoryItemsByYearDay = <T extends HistoryItem = HistoryItem>(
  result: HistoryItemsByYearDate<T>,
  item: T
) => {
  // Nested Grouping
  // via https://stackoverflow.com/questions/53929908/nested-array-group-by-with-lodash

  // Get year + format date for current item
  const itemYear = new Date(item.created).getFullYear();
  const itemDateFormat = format(item.created, 'MMMM do');

  // Get corresponding year (or insert) key from accumulator
  const year = (result[itemYear] = result[itemYear] || {});

  // Get corresponding date key from the year object
  const date = (year[itemDateFormat] = year[itemDateFormat] || []);

  date.push(item);

  return result;
};
